import React, { useState, useEffect } from 'react'
import Main from './MainCall2'
import { getUserDetailsByNumberExotel } from '../../AdminActionCreator.component';
import UserLogo from '../../../../../images/rewampimages/user.png'
import borrower1 from '../../../../../images/borrower1.png'
import moment from 'moment';
import Skeleton from '@mui/material/Skeleton';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { getcallTemplatecampaignsByData, getPreviouscallLogsHisotryByNumber } from '../../CommunicationModule/ActionCreator'
import { getRecoveryAllcommentList, SaveOrUpdatecommentRecoveryByData, GetDecryptedNumberFromAmeyoExotelUsingMaskedNumber } from '../../AdminActionCreator.component';
import CallIcon from '@mui/icons-material/Call';

export default function callDashboard({ admin }) {
    const [showcommentPopup, setshowcommentPopup] = useState({ show: false, data: {} })
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [userData, setUserData] = useState({})
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [CampaignId, setCampaignId] = useState(null);
    const [showData, setShowData] = useState(false)
    const [loader, setLoader] = useState(false)
    const [inputNumber, setInputNumber] = useState('')
    const [selectedCampaign, setselectedCampaign] = useState('')
    const [campaignList, setcampaignList] = useState([])
    const [callData, setcallData] = useState({})
    const [callingNumbersName, setcallingNumbersName] = useState('')


    const [AllcommentList, setAllcommentList] = useState([])
    const [commentPayload, setcommentPayload] = useState({
        comment: "",
        date: "",
        remark: ""
    })


    const handleNumber = async (data) => {
        console.log("data", data)
        const str = data?.additionalParams?.length > 0 ? JSON.parse(data?.additionalParams) : "";
        console.log("str", str)
        setCampaignId(str?.campaignId || null);

        if (str.callType == "outbound.manual.dial" || str.callType == "inbound.call.dial") {
            setPhoneNumber(str?.phone || null);
        } else {
            const phone = str?.customerInfo?.length > 0 ? JSON.parse(str?.customerInfo) : "";
            if (/^\d+$/.test(phone.phone1)) {
                setPhoneNumber(phone?.phone1 || null);
            } else {
                GetDecryptedNumberFromAmeyoExotelUsingMaskedNumberFn(phone?.phone1)
                // setPhoneNumber(value);
                //  MainApi(value)
            }
        }

    };

    const GetDecryptedNumberFromAmeyoExotelUsingMaskedNumberFn = (number) => {
        console.log("number", number)
        GetDecryptedNumberFromAmeyoExotelUsingMaskedNumber(number, callback => {
            setPhoneNumber(callback);
            console.log("valueNEwPrama", callback)
            MainApi(callback)
        })
    }



    const handleclosePopup = () => {
        setShowData(false)
        setUserData({});
        setPhoneNumber(null)
        setCampaignId(null)
    }

    useEffect(() => {
        console.log("phoneNumber:", phoneNumber, "CampaignId:", CampaignId)
        if (!phoneNumber || !CampaignId) return;

        // let campaignId = 0;
        MainApi(phoneNumber)
    }, [phoneNumber, CampaignId]);


    const MainApi = (number) => {
        setShowData(true)
        setLoader(true)
        console.log("phoneNumber2:", number, "CampaignId2:", CampaignId)
        getUserDetailsByNumberExotel(number, CampaignId, (callback) => {
            console.log("call::", callback)
            setLoader(false)
            if (callback?.status == 200 && callback?.message == 'success') {
                console.log("call2", callback)
                setUserData(callback?.data);
                const matchedNumber = Object.keys(callback?.data?.callingArray)?.length > 0 ? Object.keys(callback?.data?.callingArray)?.filter((el) => el == number) : ""
                if (matchedNumber.length > 0) {
                    setcallingNumbersName(callback?.data?.callingArray[matchedNumber[0]]);
                } else {
                    setcallingNumbersName("");
                }
            } else {
                setUserData({});
            }
        });
        getPreviouscallLogsHisotryByNumber(number, (callback) => {
            console.log("call", callback)
            setLoader(false)
            if (callback?.status == 200 && callback?.message == 'success') {
                setcallData(callback?.data);
            } else {
                setcallData({});
            }
        });
    }


    useEffect(() => {
        getcallTemplatecampaignsByDataFn()
        getRecoveryAllcommentListFn()
    }, [])


    const handleSearch = () => {
        if (inputNumber?.length == 10) {
            setPhoneNumber(inputNumber)
        } else {
            setPopup({ show: true, popupStatus: "Phone Number should be of 10 Digits" })
            removePopup()
        }
        if (selectedCampaign?.length !== 0) {
            setCampaignId(selectedCampaign)
        } else {
            setPopup({ show: true, popupStatus: "Please Select a Campaign" })
            removePopup()
        }
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const getcallTemplatecampaignsByDataFn = () => {
        getcallTemplatecampaignsByData(true, callback => {
            setcampaignList(callback?.data)
        })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const getRecoveryAllcommentListFn = () => {
        setLoader(true)
        getRecoveryAllcommentList(callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback?.length > 0) {
                setAllcommentList(callback)
            } else {
                setAllcommentList([])
            }
        })
    }

    const generateTimeOptions = () => {
        const times = [];
        const start = new Date();
        start.setHours(8, 0, 0, 0); // 8:00 AM
        const end = new Date();
        end.setHours(18, 0, 0, 0); // 6:00 PM

        while (start <= end) {
            const hours = start.getHours();
            const minutes = start.getMinutes();
            const formattedTime = start.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
            times.push(formattedTime);
            start.setMinutes(minutes + 15); // +15 minutes
        }

        return times;
    };

    const handleSavecomment = () => {
        console.log("comme", showcommentPopup)
        //  setshowcommentPopup({show:false,data:{}})

        const data = {
            "loanId": userData?.loanId,
            "comment": commentPayload?.comment,
            "remark": commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ? commentPayload?.date + "T" + commentPayload?.remark : commentPayload?.remark,
            "commentBy": admin?.emailId,
            "emiId": showcommentPopup?.data?.emiId || ""
        }
        console.log("dat", data)
        setLoader(true)
        SaveOrUpdatecommentRecoveryByData(data, callback => {
            setLoader(false)
            if (callback == 'success') {
                setshowcommentPopup({ show: false, data: {} })
            } else {
                setshowcommentPopup({ show: false, data: {} })
            }
            setcommentPayload({
                comment: "",
                date: "",
                remark: ""
            })
        })
    }


    return (
        <>
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''
            }
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="row">
                    <div className="col-sm-4 col-xs-12">
                        <Main handleNumber={handleNumber} />
                    </div>
                    <div className="col-sm-8 col-xs-12">

                        <div className='row'>
                            <div className="col-sm-3 col-xs-12">
                                <label htmlFor="">Mobile No.</label>
                                <input type='number' className='form-control' value={inputNumber} onChange={(e) => setInputNumber(e.target.value)} />
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <label htmlFor="">Campaign</label>
                                <select className='form-control' value={selectedCampaign} onChange={(e) => setselectedCampaign(e.target.value)} >
                                    <option value={""}>Select Campagin</option>
                                    {
                                        campaignList?.length > 0 ? campaignList?.map((val, id) => {
                                            return (
                                                <option value={val?.campaignId}>{val?.campaignName}</option>
                                            )
                                        })
                                            : ''}

                                </select>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <button className='btn btn-primary' onClick={() => handleSearch()} style={{ marginTop: '22px', padding: '9px' }}><i className='fa fa-search'></i></button>
                            </div>
                        </div>
                        <hr />
                        {
                            showData ?
                                !loader ?
                                    <>
                                        <div className="details-new" style={{
                                            borderRadius: '20px',
                                            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px', padding: '10px'
                                        }}>
                                            <i className='fa fa-times' style={{ color: "red", float: 'right', cursor: 'pointer' }} onClick={() => handleclosePopup()}></i>
                                            {
                                                userData && Object.keys(userData)?.length > 0 ?
                                                    <>
                                                    <h4 style={{margin:'0'}}><b>Calling Person - ({callingNumbersName ?? ""})</b></h4>
                                                        <div className="details-body" style={{ marginTop: '20px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                            <div className="details-head">
                                                                <div className="row">
                                                                    <div className="col-sm-11 col-xs-11">
                                                                        <div style={{ marginTop: '6px' }}>
                                                                            <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                                            <b style={{ marginTop: '14px' }}>Personal Information </b>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                                                <div className="row" >
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Application Id</label>
                                                                        <p>{userData?.applicationId || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>First Name</label>
                                                                        <p>{userData?.firstName || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Last Name</label>
                                                                        <p>{userData?.lastName || "-"}</p>
                                                                    </div>

                                                                </div>
                                                                <div className="row" >

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Email Id</label>
                                                                        <p>{userData?.email || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Primary Number</label>
                                                                        <p>{userData?.primaryNumber || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Alternate Number</label>
                                                                        <p>{userData?.alternativeNumber || "-"}</p>
                                                                    </div>

                                                                </div>
                                                                <div className="row" >
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Gender</label>
                                                                        <p>{userData?.gender || "N/A"}</p>
                                                                    </div>

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>D.O.B</label>
                                                                        <p>{userData?.dob || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Designation</label>
                                                                        <p>{userData?.designation || "-"}</p>
                                                                    </div>


                                                                </div>
                                                                <div className="row" >

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Name 1</label>
                                                                        <p>{userData?.refName1 || "N/A"}</p>
                                                                    </div>

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Number 1</label>
                                                                        <p>{userData?.refNumber1 || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Name 2</label>
                                                                        <p>{userData?.refName2 || "N/A"}</p>
                                                                    </div>


                                                                </div>
                                                                <div className="row" >

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Number 2</label>
                                                                        <p>{userData?.refNumber2 || "N/A"}</p>
                                                                    </div>

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Name 3</label>
                                                                        <p>{userData?.refName3 || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Refrence Number 3</label>
                                                                        <p>{userData?.refNumber3 || "N/A"}</p>
                                                                    </div>


                                                                </div>
                                                                <div className="row" >
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Form Status</label>
                                                                        <p>{userData?.formStatus || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Created Date</label>
                                                                        <p>{userData?.createdDate || "N/A"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Last Login Date</label>
                                                                        <p>{userData?.lastLoginDate || "N/A"}</p>
                                                                    </div>


                                                                </div>
                                                                <div className="row" >
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Organization Name</label>
                                                                        <p>{userData?.organizationName || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Salary</label>
                                                                        <p>{userData?.salary || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Approve Amount</label>
                                                                        <p>{userData?.approvalAmount || "-"}</p>
                                                                    </div>

                                                                </div>
                                                                <div className="row" >
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Tenure</label>
                                                                        <p>{userData?.tenure || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>KYC</label>
                                                                        <p>{userData?.kyc || "-"}</p>
                                                                    </div>

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>E-Sign</label>
                                                                        <p>{userData?.esign || "-"}</p>
                                                                    </div>

                                                                </div>
                                                                <div className="row" >

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>E-Nach</label>
                                                                        <p>{userData?.enach || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Obligations</label>
                                                                        <p>{userData?.obligations || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Cibil Score</label>
                                                                        <p>{userData?.cibilScore || "-"}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="row" >

                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Surplus</label>
                                                                        <p>{userData?.surplus || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Processing Fees</label>
                                                                        <p>{userData?.processingFee || "-"}</p>
                                                                    </div>
                                                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                        <label>Disburse Amount</label>
                                                                        <p>{userData?.disburseAmount || "-"}</p>
                                                                    </div>
                                                                </div>



                                                            </div>
                                                        </div>
                                                        {
                                                            userData?.emiDetails?.length > 0 ?

                                                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                                    <div className="details-head">
                                                                        <div className="row">
                                                                            <div className="col-sm-11 col-xs-11">
                                                                                <div style={{ marginTop: '6px' }}>
                                                                                    <img src={borrower1} style={{ width: '20px' }} /> &nbsp;
                                                                                    <b style={{ marginTop: '14px' }}>EMI Information</b>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                    <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>

                                                                        <div className="row" >

                                                                            <div className='overflow-auto' style={{ margin: '0 10px' }}>
                                                                                <table className='phocket-table'>
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className='text-center'>DPD Days</th>
                                                                                            <th className='text-center'>Overdue Amount</th>
                                                                                            <th className='text-center'>EMI Status</th>
                                                                                            <th className='text-center'>EMI Amount</th>
                                                                                            <th className='text-center'>Due Date</th>
                                                                                            <th className='text-center'>Actions</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            userData?.emiDetails?.map((val, id) => {
                                                                                                return (
                                                                                                    <tr key={id}>
                                                                                                        <td className='text-center'>{val?.dpdDays || "-"}</td>
                                                                                                        <td className='text-center'>{val?.overdueAmount || "-"}</td>
                                                                                                        <td className='text-center'>{val?.emiStatus || "-"}</td>
                                                                                                        <td className='text-center'>{val?.emiAmount || "-"}</td>
                                                                                                        <td className='text-center'>{val?.dueDate || "-"}</td>
                                                                                                        <td className='text-center'>
                                                                                                            {
                                                                                                                val?.emiStatus == "Paid" ? ""
                                                                                                                    :
                                                                                                                    val?.comment == true ?
                                                                                                                        <button className='btn btn-primary' onClick={() => setshowcommentPopup({ show: true, data: val })}>Add Comment</button>
                                                                                                                        : ""
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </tbody>

                                                                                </table>
                                                                            </div>

                                                                        </div>


                                                                    </div>
                                                                </div>
                                                                : ""}
                                                        {
                                                            Object.keys(callData)?.length > 0 ?

                                                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                                    <div className="details-head">
                                                                        <div className="row">
                                                                            <div className="col-sm-11 col-xs-11">
                                                                                <div style={{ marginTop: '6px' }}>
                                                                                    {/* <img src={borrower1} style={{ width: '20px' }} /> &nbsp; */}
                                                                                    <CallIcon style={{ width: '20px' }} />&nbsp;

                                                                                    <b style={{ marginTop: '14px' }}>Previous Call Information</b>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                    <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>

                                                                        <div className="row" >
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Agent Id</label>
                                                                                <p>{callData?.agentID || "N/A"}</p>
                                                                            </div>
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Call Status</label>
                                                                                <p>{callData?.callStatus || "N/A"}</p>
                                                                            </div>
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Disposition</label>
                                                                                <p>{callData?.disposition || "N/A"}</p>
                                                                            </div>

                                                                        </div>
                                                                        <div className="row" >
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Call Duration</label>
                                                                                <p>{callData?.callDuration || "N/A"}</p>
                                                                            </div>
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Call Start</label>
                                                                                <p>{moment(callData?.callStart).format("DD-MM-YYYY HH:MM:SS") || "N/A"}</p>
                                                                            </div>
                                                                            <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                                <label>Call End</label>
                                                                                <p>{moment(callData?.callEnd).format("DD-MM-YYYY HH:MM:SS") || "N/A"}</p>
                                                                            </div>

                                                                        </div>


                                                                    </div>
                                                                </div>
                                                                : ""}
                                                    </>
                                                    :
                                                    <h4><i>No Data Found</i></h4>
                                            }
                                        </div>

                                    </>
                                    :
                                    <Skeleton variant="rectangular" width={"100%"} height={800} />
                                : ''}

                        {
                            showcommentPopup?.show ?
                                <div className="background-blur">

                                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '20%' }}>
                                        <i onClick={() => setshowcommentPopup({ show: false, data: {} })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                        <div>
                                            <h3 className='text-center'>Add Comment</h3>
                                        </div>
                                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                            <div style={{ textAlign: 'left' }}>
                                                <label htmlFor="">Select Comment</label>
                                                <select className='form-control' value={commentPayload?.comment} onChange={(e) => setcommentPayload({ remark: "", "comment": e.target.value, date: "" })} style={{
                                                    width: commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ? '70%' : "100%"
                                                }}>
                                                    <option value="">Select</option>
                                                    {
                                                        AllcommentList && AllcommentList?.length > 0 ? AllcommentList?.map((v) => {
                                                            return (
                                                                <option value={v}>{v}</option>
                                                            )
                                                        })
                                                            : ''}
                                                </select>
                                            </div>
                                            {
                                                commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                                    <div style={{ textAlign: 'left' }}>
                                                        <label htmlFor="">Date</label>
                                                        <input
                                                            className='form-control'
                                                            type="date"
                                                            value={commentPayload?.date} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "date": e.target.value }))} style={{ width: '100%' }} />
                                                    </div>
                                                    : ''}
                                            {
                                                commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                                    <div style={{ textAlign: 'left' }}>
                                                        <label htmlFor="">Time</label>
                                                        <select className='form-control' value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }} >

                                                            <option value="">Select</option>
                                                            {
                                                                generateTimeOptions()?.map((time, index) => (
                                                                    <option key={index} value={time}>
                                                                        {time}
                                                                    </option>
                                                                ))
                                                            }


                                                        </select>

                                                    </div>
                                                    : ''}
                                            {
                                                commentPayload?.comment == "Language Barrier" ?
                                                    <div style={{ textAlign: 'left' }}>
                                                        <label>Language</label>
                                                        <select className='form-control' value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }}>
                                                            <option value={""}>Select</option>
                                                            <option value={"Hindi"}>Hindi</option>
                                                            <option value={"English"}>English</option>
                                                            <option value={"Bengali"}>Bengali</option>
                                                            <option value={"Odia"}>Odia</option>
                                                            <option value={"Tamil"}>Tamil</option>
                                                            <option value={"Telugu"}>Telugu</option>
                                                            <option value={"Kannada"}>Kannada</option>
                                                        </select>
                                                    </div>
                                                    : ""}
                                        </div>
                                        <div className='text-center' style={{ marginTop: '15px' }}>
                                            <button className='btn btn-primary' disabled={commentPayload?.comment == "" || commentPayload?.comment == null || commentPayload?.comment == undefined ? true : false} onClick={() => handleSavecomment()}>Save</button>
                                        </div>
                                    </div>
                                </div>
                                : ""}
                    </div>
                </div>
            </div>





        </>
    )
}
